/** Chuẩn hóa email/SĐT liên hệ — email không phân biệt hoa thường. */
export function normalizeContact(value: string): string {
  return value.trim().toLowerCase();
}